'use strict';

import React from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import Row from '../tag/Row';
import Span from '../tag/Span';
import Alert from '../Alert';

import { connect } from 'react-redux';
import { withPageBase } from '../PageBase';
import { selectShowAppointmentPagePlaceholder } from '../../data/appointment/selector';
import {
  resetAppointmentReservation,
  resetAvailableSlots,
} from '../../data/appointment/actions';
import ToastHOC from '../ToastHOC';
import ReservedAppointments from './ReservedAppointments';
import ReservableAppointments from './reserve/ReservableAppointments';
import QueueAppointments from './reserve/QueueAppointments';
import { APPOINTMENTS } from '../../data/reducer';

const { id: module_id } = module;

class AppointmentsPage extends React.Component {
  constructor(props) {
    super(props);

    this.props.resetAppointmentReservation();
    this.props.resetAvailableSlots();

    this.state = {
      showAlreadyRescheduledTooltip: null,
    };
  }

  render() {
    const {
      toasts,
      showPlaceholder,
      clinicsIsFetching,
      clinicsData,
      clinicsError,
      queueAppointmentsIsFetching,
      queueAppointmentsData,
      queueAppointmentsError,
    } = this.props;

    let toastElements = [];

    if (toasts) {
      toastElements = toasts.map((item) => <Alert {...item.spec} />);
    }

    const showQueueAndReservableAppointments =
      !clinicsIsFetching &&
      !queueAppointmentsIsFetching &&
      (clinicsData.length > 0 || queueAppointmentsData.length > 0) &&
      !clinicsError &&
      !queueAppointmentsError;

    return (
      <>
        <div>
          {toastElements.length > 0 && (
            <Row>
              <Span>{toastElements}</Span>
            </Row>
          )}
          {!showPlaceholder && (
            <>
              <FormattedMessage
                id={`${module_id}.fine.payment.info`}
                values={{
                  finePaymentLink: (chunks) => (
                    <a
                      className="reservation-info-link"
                      href="https://www.pirha.fi/asiakkaalle/asiakasmaksut/kayttamatta-ja-peruuttamatta-jatetyn-palvelun-maksu"
                      target="_blank"
                    >
                      {chunks}
                    </a>
                  )
                }}
              />
              <h2 className={'subheading-gray'}>
                <FormattedMessage id={`${module_id}.subheading`} />
              </h2>
              {showQueueAndReservableAppointments ? (
                <>
                  <Row>
                    <Span>
                      <QueueAppointments />
                    </Span>
                  </Row>
                  <Row>
                    <Span>
                      <ReservableAppointments />
                    </Span>
                  </Row>
                </>
              ) : (
                <p>
                  <FormattedMessage
                    id={`${module_id}.no.reservable.appointments`}
                  />
                </p>
              )}
              <Row>
                <Span>
                  <ReservedAppointments />
                </Span>
              </Row>
            </>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    isFetching: clinicsIsFetching,
    data: clinicsData,
    error: clinicsError,
    pinCodeIsValid,
    pinCodeError,
  } = state[APPOINTMENTS].reservation.clinics;
  const {
    isFetching: queueAppointmentsIsFetching,
    data: queueAppointmentsData,
    error: queueAppointmentsError,
  } = state[APPOINTMENTS].queueAppointments;
  return {
    clinicsIsFetching,
    clinicsData,
    clinicsError,
    showPlaceholder: selectShowAppointmentPagePlaceholder(state),
    pinCodeIsValid,
    pinCodeError,
    queueAppointmentsIsFetching,
    queueAppointmentsData,
    queueAppointmentsError,
  };
};

const mapDispatchToProps = (dispatch) => ({
  resetAppointmentReservation: () => dispatch(resetAppointmentReservation()),
  resetAvailableSlots: () => dispatch(resetAvailableSlots()),
});

const toastOptions = {
  module_id: module_id,
  dismissOnUnmount: ['APPOINTMENT_RESCHEDULE_FAILED_TOAST'],
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ToastHOC(
    toastOptions,
    withRouter(
      withPageBase(AppointmentsPage, {
        title: `${module_id}.title`,
        showPlaceHolder: selectShowAppointmentPagePlaceholder,
      })
    )
  )
);
